export const staticRoutes: AppRoute.RowRoute[] = [
  {
    name: 'index',
    path: '/',
    title: '首页',
    requiresAuth: true,
    icon: 'local:Index',
    componentPath: '/index.vue',
    pinTab: true,
    id: 0,
    pid: null,
    singleParent: true, // 单一父级菜单
    order: 1,
  },
  // {
  //   name: 'domainProduct',
  //   path: '/domainProduct',
  //   title: '域名产品',
  //   requiresAuth: true,
  //   icon: 'local:LogoWordpress',
  //   menuType: 'dir',
  //   componentPath: null,
  //   id: 1,
  //   pid: null,
  // },
  // {
  //   name: 'domainRegister',
  //   path: '/domainProduct/domainRegister',
  //   title: '域名注册',
  //   requiresAuth: true,
  //   menuType: 'page',
  //   componentPath: '/domainProduct/domainRegister.vue',
  //   id: 110,
  //   pid: 11,
  // },
  {
    name: 'domainIndex',
    path: '/domainProduct/index',
    title: '域名总览',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/domainProduct/index.vue',
    id: 107,
    pid: 10,
    order: 1,
  },
  {
    name: 'domainManage',
    path: '/domainProduct/domainManage',
    title: '域名管理',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/domainProduct/domainManage.vue',
    id: 101,
    pid: 10,
    keepAlive: true,
    order: 1,
  },
  {
    name: 'domainManageInfo',
    path: '/domainProduct/domainManageInfo',
    title: '域名信息',
    requiresAuth: true,
    menuType: 'page',
    activeMenu: '/domainProduct/domainManage',
    componentPath: '/domainProduct/domainManageInfo.vue',
    id: 1010,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'domain-batchRenewal',
    path: '/domainProduct/batchRenewal',
    title: '批量续费',
    requiresAuth: true,
    menuType: 'page',
    activeMenu: '/domainProduct/domainManage',
    componentPath: '/domainProduct/batchRenewal.vue',
    id: 1011,
    pid: null,
    hide: true,
  },
  {
    name: 'domainTransfer',
    path: '/domainProduct/domainTransfer',
    title: '域名转入',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/domainProduct/domainTransfer/index.vue',
    id: 102,
    pid: 10,
    keepAlive: true,
    addCacheRoutes: true,
    order: 4,
  },
  {
    name: 'domainTransferOut',
    path: '/domainProduct/domainTransferOut',
    title: '域名过户',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/domainProduct/domainTransferOut/index.vue',
    id: 103,
    pid: 10,
    keepAlive: true,
    addCacheRoutes: true,
    order: 5,
  },
  {
    name: 'domainTemplate',
    path: '/domainProduct/domainTemplate/list',
    title: '资料模板',
    requiresAuth: true,
    componentPath: '/domainProduct/domainTemplate/index.vue',
    id: 104,
    pid: 10,
    keepAlive: true,
    order: 6,
  },
  {
    name: 'domainTemplateAdd',
    path: '/domainProduct/domainTemplate/add',
    title: '资料模板添加',
    requiresAuth: true,
    componentPath: '/domainProduct/domainTemplate/add.vue',
    activeMenu: '/domainProduct/domainTemplate/list',
    id: 1040,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'domainTemplateInfo',
    path: '/domainProduct/domainTemplate/info/:id',
    title: '资料模板详情',
    requiresAuth: true,
    componentPath: '/domainProduct/domainTemplate/info.vue',
    activeMenu: '/domainProduct/domainTemplate/list',
    id: 1041,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  // {
  //   name: 'domainSafety',
  //   path: '/domainProduct/domainSafety',
  //   title: '域名安全',
  //   requiresAuth: true,
  //   menuType: 'page',
  //   componentPath: '/domainProduct/domainSafety.vue',
  //   id: 115,
  //   pid: 11,
  // },
  {
    name: 'domainGroup',
    path: '/domainProduct/domainGroup',
    title: '域名分组',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/domainProduct/domainGroup/index.vue',
    id: 105,
    pid: 10,
    order: 7,
  },
  {
    name: 'domainRepurchaseList',
    path: '/domainProduct/domainRepurchase/list',
    title: '域名回购',
    requiresAuth: true,
    componentPath: '/domainProduct/domainRepurchase/list.vue',
    id: 106,
    pid: 10,
    keepAlive: true,
    order: 2,
  },
  {
    name: 'domainRepurchaseInfo',
    path: '/domainProduct/domainRepurchase/info/:id',
    title: '域名回购详情',
    requiresAuth: true,
    componentPath: '/domainProduct/domainRepurchase/info.vue',
    activeMenu: '/domainProduct/domainRepurchase/list',
    id: 1061,
    pid: null,
    hide: true,
  },

  {
    name: 'qualityAssurance',
    path: '/qualityAssurance/',
    title: '全球域名管理',
    requiresAuth: true,
    icon: 'local:LogoWordpress',
    menuType: 'dir',
    componentPath: null,
    id: 10,
    pid: null,
    order: 2,
  },
  // {
  //   name: 'qualityAssuranceIndex',
  //   path: '/qualityAssurance/index',
  //   title: '品保总览',
  //   requiresAuth: true,
  //   menuType: 'page',
  //   componentPath: '/qualityAssurance/index.vue',
  //   id: 1001,
  //   pid: 10,
  // },
  {
    name: 'monitorManageList',
    path: '/qualityAssurance/monitorManage/list',
    title: '监测管理',
    requiresAuth: true,
    componentPath: '/qualityAssurance/monitorManage/list.vue',
    id: 1002,
    pid: 10,
    keepAlive: true,
  },
  {
    name: 'monitorManageInfo',
    path: '/qualityAssurance/monitorManage/:id',
    title: '监测管理详情',
    requiresAuth: true,
    componentPath: '/qualityAssurance/monitorManage/info.vue',
    activeMenu: '/qualityAssurance/monitorManage/list',
    id: 1003,
    pid: null,
    hide: true,
  },
  {
    name: 'newTLDLockList',
    path: '/qualityAssurance/newTLDLock/list',
    title: '新顶级域名锁定',
    requiresAuth: true,
    componentPath: '/qualityAssurance/newTLDLock/list.vue',
    id: 1003,
    pid: 10,
    keepAlive: true,
  },
  {
    name: 'newTLDLockListInfo',
    path: '/qualityAssurance/newTLDLock/:id',
    title: '新顶级域名锁定详情',
    requiresAuth: true,
    componentPath: '/qualityAssurance/newTLDLock/info.vue',
    activeMenu: '/qualityAssurance/newTLDLock/list',
    id: 1004,
    pid: null,
    hide: true,
  },
  {
    name: 'protectionList',
    path: '/qualityAssurance/protection/list',
    title: '域名/品牌维权',
    requiresAuth: true,
    componentPath: '/qualityAssurance/protection/list.vue',
    id: 1005,
    pid: 10,
    keepAlive: true,
  },
  {
    name: 'protectionListInfo',
    path: '/qualityAssurance/protection/:id',
    title: '域名/品牌维权详情',
    requiresAuth: true,
    componentPath: '/qualityAssurance/protection/info.vue',
    activeMenu: '/qualityAssurance/protection/list',
    id: 1006,
    pid: null,
    hide: true,
  },
  {
    name: 'customizationList',
    path: '/qualityAssurance/customization/list',
    title: '定制化产品',
    requiresAuth: true,
    componentPath: '/qualityAssurance/customization/list.vue',
    id: 1007,
    pid: 10,
    keepAlive: true,
  },
  {
    name: 'customizationInfo',
    path: '/qualityAssurance/customization/:id',
    title: '定制化产品详情',
    requiresAuth: true,
    componentPath: '/qualityAssurance/customization/info.vue',
    activeMenu: '/qualityAssurance/customization/list',
    id: 1008,
    pid: null,
    hide: true,
  },
  {
    name: 'cloudDns',
    path: '/domainProduct/cloudDns/',
    title: '云解析DNS',
    requiresAuth: true,
    componentPath: '/domainProduct/cloudDns/index.vue',
    id: 108,
    pid: 10,
    keepAlive: true,
    order: 1,
  },
  {
    name: 'cloudDnsInfo',
    path: '/domainProduct/cloudDns/info',
    title: '云解析详情',
    requiresAuth: true,
    componentPath: '/domainProduct/cloudDns/cloudDnsList/info.vue',
    activeMenu: '/domainProduct/cloudDns/',
    id: 1081,
    pid: null,
    hide: true,
  },
  {
    name: 'cloudDnsAdd',
    path: '/domainProduct/cloudDns/add',
    title: '云解析添加解析',
    requiresAuth: true,
    componentPath: '/domainProduct/cloudDns/cloudDnsList/add.vue',
    activeMenu: '/domainProduct/cloudDns/',
    id: 1082,
    pid: null,
    hide: true,
  },
  {
    name: 'cloudDnsAddDomain',
    path: '/domainProduct/cloudDns/addDomain',
    title: '云解析添加域名',
    requiresAuth: true,
    componentPath: '/domainProduct/cloudDns/cloudDnsList/addDomain.vue',
    activeMenu: '/domainProduct/cloudDns/',
    id: 1083,
    pid: null,
    hide: true,
    keepAlive: true,
    addCacheRoutes: true,
  },
  {
    name: 'intellectualProperty',
    path: '/intellectualProperty/',
    title: '知识产权管理',
    requiresAuth: true,
    icon: 'local:Layers',
    id: 2,
    menuType: 'dir',
    componentPath: null,
    pid: null,
    order: 3,
  },
  {
    name: 'intellectualPropertyIndex',
    path: '/intellectualProperty/index',
    title: '知产总览',
    requiresAuth: true,
    componentPath: '/intellectualProperty/index.vue',
    id: 201,
    pid: 2,
  },
  {
    name: 'intellectualPropertyBrand',
    path: '/intellectualProperty/brand/',
    title: '商标管理',
    requiresAuth: true,
    componentPath: '/intellectualProperty/brand/list.vue',
    id: 202,
    pid: 2,
    keepAlive: true,
  },
  {
    name: 'intellectualPropertyBrandInfo',
    path: '/intellectualProperty/brand/:id',
    title: '商标详情',
    requiresAuth: true,
    componentPath: '/intellectualProperty/brand/info.vue',
    activeMenu: '/intellectualProperty/brand/',
    id: 2020,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'intellectualPropertyCopyright',
    path: '/intellectualProperty/copyright/',
    title: '版权管理',
    requiresAuth: true,
    componentPath: '/intellectualProperty/copyright/list.vue',
    id: 203,
    pid: 2,
    keepAlive: true,
  },
  {
    name: 'intellectualPropertyCopyrightInfo',
    path: '/intellectualProperty/copyright/:id',
    title: '版权详情',
    requiresAuth: true,
    componentPath: '/intellectualProperty/copyright/info.vue',
    activeMenu: '/intellectualProperty/copyright/',
    id: 2030,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'intellectualPropertyPatent',
    path: '/intellectualProperty/patent/',
    title: '专利管理',
    requiresAuth: true,
    componentPath: '/intellectualProperty/patent/list.vue',
    id: 204,
    pid: 2,
    keepAlive: true,
  },
  {
    name: 'intellectualPropertyPatentInfo',
    path: '/intellectualProperty/patent/:id',
    title: '专利详情',
    requiresAuth: true,
    componentPath: '/intellectualProperty/patent/info.vue',
    activeMenu: '/intellectualProperty/patent/',
    id: 2040,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'intellectualPropertyCompany',
    path: '/intellectualProperty/company/',
    title: '公司注册',
    requiresAuth: true,
    componentPath: '/intellectualProperty/company/list.vue',
    id: 205,
    pid: 2,
    keepAlive: true,
  },
  {
    name: 'intellectualPropertyReportInfo',
    path: '/intellectualProperty/reportdocument/',
    title: '报告文件',
    requiresAuth: true,
    componentPath: '/intellectualProperty/reportdocument/list.vue',
    id: 206,
    pid: 2,
    keepAlive: true,
  },
  {
    name: 'intellectualPropertyReportDocument',
    path: '/intellectualProperty/company/:id',
    title: '公司注册详情',
    requiresAuth: true,
    componentPath: '/intellectualProperty/company/info.vue',
    activeMenu: '/intellectualProperty/company/',
    id: 2050,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'idc',
    path: '/idc/',
    title: '云计算与邮箱',
    requiresAuth: true,
    icon: 'local:Easel',
    id: 3,
    menuType: 'dir',
    componentPath: null,
    pid: null,
    order: 5,
  },
  {
    name: 'idcIndex',
    path: '/idc/index',
    title: 'IDC总览',
    requiresAuth: true,
    componentPath: '/idc/index.vue',
    id: 301,
    pid: 3,
  },
  // {
  //   name: 'idcRenewal',
  //   path: '/idc/renewal/:id',
  //   title: 'IDC产品续费',
  //   requiresAuth: true,
  //   componentPath: '/idc/renewal.vue',
  //   id: 3010,
  //   pid: null,
  //   hide: true,
  //   // withoutTab: true,
  // },
  {
    name: 'idcBatchRenewal',
    path: '/idc/batchRenewal',
    title: 'IDC产品续费',
    requiresAuth: true,
    componentPath: '/idc/batchRenewal.vue',
    id: 3011,
    pid: null,
    hide: true,
  },

  {
    name: 'dataCenter',
    path: '/idc/dataCenter/',
    // redirect: '/idc/dataCenter/serverRental/list',
    title: '数据中心',
    requiresAuth: true,
    componentPath: '/idc/dataCenter/index.vue',
    id: 302,
    pid: 3,
    keepAlive: true,
  },
  {
    name: 'idcServerRentalList',
    path: '/idc/dataCenter/serverRental/list',
    title: '服务器租用',
    requiresAuth: true,
    componentPath: '/idc/dataCenter/serverRental/list.vue',
    activeMenu: '/idc/dataCenter/',
    id: 3020,
    pid: null,
    hide: true,
  },
  {
    name: 'idcServerRentalInfo',
    path: '/idc/dataCenter/serverRental/:id',
    title: '服务器租用详情',
    requiresAuth: true,
    componentPath: '/idc/dataCenter/serverRental/info.vue',
    activeMenu: '/idc/dataCenter/',
    id: 3021,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'idcServerHostingList',
    path: '/idc/dataCenter/serverHosting/list',
    title: '服务器托管',
    requiresAuth: true,
    componentPath: '/idc/dataCenter/serverHosting/list.vue',
    activeMenu: '/idc/dataCenter/',
    id: 3022,
    pid: null,
    hide: true,
  },
  {
    name: 'idcServerHostingInfo',
    path: '/idc/dataCenter/serverHosting/:id',
    title: '服务器托管详情',
    requiresAuth: true,
    componentPath: '/idc/dataCenter/serverHosting/info.vue',
    activeMenu: '/idc/dataCenter/',
    id: 3023,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'idcValueAddServiceList',
    path: '/idc/dataCenter/valueAddService/list',
    title: '数据中心增值服务',
    requiresAuth: true,
    componentPath: '/idc/dataCenter/valueAddService/list.vue',
    activeMenu: '/idc/dataCenter/',
    id: 3024,
    pid: null,
    hide: true,
  },
  {
    name: 'cloud',
    path: '/idc/cloud/',
    title: '云计算',
    requiresAuth: true,
    componentPath: '/idc/cloud/index.vue',
    id: 303,
    pid: 3,
    keepAlive: true,
  },
  {
    name: 'cloudHostList',
    path: '/idc/cloud/cloudHost/list',
    title: '云主机',
    requiresAuth: true,
    componentPath: '/idc/cloud/cloudHost/list.vue',
    activeMenu: '/idc/cloud/',
    id: 3030,
    pid: null,
    hide: true,
  },
  {
    name: 'cloudHostInfo',
    path: '/idc/cloud/cloudHost/:id',
    title: '云主机详情',
    requiresAuth: true,
    componentPath: '/idc/cloud/cloudHost/info.vue',
    activeMenu: '/idc/cloud/',
    id: 3031,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'addValueList',
    path: '/idc/cloud/addValue/list',
    title: '云增值产品',
    requiresAuth: true,
    componentPath: '/idc/cloud/addValue/list.vue',
    activeMenu: '/idc/cloud/',
    id: 3032,
    pid: null,
    hide: true,
  },
  {
    name: 'corporateEmailList',
    path: '/idc/corporateEmail/list',
    title: '企业邮箱',
    requiresAuth: true,
    componentPath: '/idc/corporateEmail/list.vue',
    id: 305,
    pid: 3,
    keepAlive: true,
  },
  {
    name: 'corporateEmailInfo',
    path: '/idc/corporateEmail/info/:id',
    title: '企业邮箱详情',
    requiresAuth: true,
    componentPath: '/idc/corporateEmail/info.vue',
    id: 3050,
    pid: null,
    hide: true,
    // withoutTab: true,
  },

  {
    name: 'bandwidth',
    path: '/idc/bandwidth/',
    redirect: '/idc/bandwidth/list',
    title: '带宽产品',
    requiresAuth: true,
    id: 307,
    pid: 3,
    keepAlive: true,
  },
  {
    name: 'bandwidthList',
    path: '/idc/bandwidth/list',
    title: '带宽产品',
    requiresAuth: true,
    componentPath: '/idc/bandwidth/list.vue',
    activeMenu: '/idc/bandwidth/',
    id: 3070,
    pid: null,
    hide: true,
  },
  {
    name: 'bandwidthInfo',
    path: '/idc/bandwidth/info/:id',
    title: '带宽产品详情',
    requiresAuth: true,
    componentPath: '/idc/bandwidth/info.vue',
    activeMenu: '/idc/bandwidth/',
    id: 3071,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'security',
    path: '/idc/security/',
    title: '信息安全',
    requiresAuth: true,
    componentPath: '/idc/security/list.vue',
    id: 310,
    pid: 3,
    keepAlive: true,
  },
  {
    name: 'securityInfo',
    path: '/idc/security/info/:id',
    title: '信息安全详情',
    requiresAuth: true,
    componentPath: '/idc/security/info.vue',
    activeMenu: '/idc/security/',
    id: 3101,
    pid: null,
    hide: true,
  },
  {
    name: 'website',
    path: '/idc/website/',
    redirect: '/idc/website/list',
    title: '网站建设',
    requiresAuth: true,
    id: 308,
    pid: 3,
    keepAlive: true,
  },
  {
    name: 'websiteList',
    path: '/idc/website/list',
    title: '网站建设',
    requiresAuth: true,
    componentPath: '/idc/website/list.vue',
    activeMenu: '/idc/website/',
    id: 3080,
    pid: null,
    hide: true,
  },
  {
    name: 'websiteInfo',
    path: '/idc/website/info/:id',
    title: '网站建设详情',
    requiresAuth: true,
    componentPath: '/idc/website/info.vue',
    activeMenu: '/idc/website/',
    id: 3081,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'itAddValue',
    path: '/idc/itAddValue/list',
    title: 'IT增值产品',
    requiresAuth: true,
    componentPath: '/idc/itAddValue/list.vue',
    id: 309,
    pid: 3,
  },
  {
    name: 'seawan',
    path: '/idc/seawan/',
    title: '网络专线管理',
    requiresAuth: true,
    icon: 'local:Seawan',
    menuType: 'dir',
    componentPath: null,
    id: 304,
    pid: null,
    order: 4,
  },
  {
    name: 'networkExpressList',
    path: '/idc/seawan/networkExpress/list',
    title: '网络快线',
    requiresAuth: true,
    componentPath: '/idc/seawan/networkExpress/list.vue',
    id: 3040,
    pid: 304,
    // 网络快线
  },
  {
    name: 'entityDedicatedLineList',
    path: '/idc/seawan/entityDedicatedLine/list',
    title: '实体专线',
    requiresAuth: true,
    componentPath: '/idc/seawan/entityDedicatedLine/list.vue',
    id: 3041,
    pid: 304,
    // withoutTab: true,
  },
  {
    name: 'liveExpressList',
    path: '/idc/seawan/liveExpress/list',
    title: '云专线',
    requiresAuth: true,
    componentPath: '/idc/seawan/liveExpress/list.vue',
    id: 3042,
    pid: 304,
    // withoutTab: true,
  },
  {
    name: 'networkExpressInfo',
    path: '/idc/seawan/networkExpress/:id',
    title: '网络专线详情',
    requiresAuth: true,
    componentPath: '/idc/seawan/networkExpress/info.vue',
    activeMenu: '/idc/seawan/networkExpress/list',
    id: 3043,
    pid: 304,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'entityDedicatedLineInfo',
    path: '/idc/seawan/entityDedicatedLine/:id',
    title: '实体专线详情',
    requiresAuth: true,
    componentPath: '/idc/seawan/entityDedicatedLine/info.vue',
    activeMenu: '/idc/seawan/entityDedicatedLine/list',
    id: 3044,
    pid: 304,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'liveExpressInfo',
    path: '/idc/seawan/liveExpress/:id',
    title: '云专线详情',
    requiresAuth: true,
    componentPath: '/idc/seawan/liveExpress/info.vue',
    activeMenu: '/idc/seawan/liveExpress/list',
    id: 3045,
    pid: 304,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'ssl',
    path: '/idc/ssl/',
    title: '数字证书管理',
    requiresAuth: true,
    icon: 'local:MenuSsl',
    menuType: 'dir',
    componentPath: null,
    id: 306,
    pid: null,
  },
  {
    name: 'sslList',
    path: '/idc/ssl/list',
    title: '证书管理',
    requiresAuth: true,
    componentPath: '/idc/ssl/list.vue',
    id: 3061,
    pid: 306,
    keepAlive: true,
  },
  {
    name: 'sslInfo',
    path: '/idc/ssl/:id',
    title: '证书详情',
    requiresAuth: true,
    componentPath: '/idc/ssl/info2.vue',
    activeMenu: '/idc/ssl/list',
    id: 3062,
    pid: 306,
    hide: true,
  },
  {
    name: 'sslMaterialList',
    path: '/idc/ssl/materialList',
    title: '证书资料',
    requiresAuth: true,
    componentPath: '/idc/ssl/material/list.vue',
    id: 3063,
    pid: 306,
  },
  {
    name: 'sslMaterialInfo',
    path: '/idc/ssl/sslMaterialInfo/:id',
    title: '证书资料详情',
    requiresAuth: true,
    componentPath: '/idc/ssl/material/info.vue',
    activeMenu: '/idc/ssl/materialList',
    id: 3064,
    pid: 306,
    hide: true,
  },
  {
    name: 'sslUploadList',
    path: '/idc/ssl/sslUpload/list',
    title: '证书上传',
    requiresAuth: true,
    componentPath: '/idc/ssl/upload/list.vue',
    id: 3065,
    pid: 306,
  },
  {
    name: 'sslUploadAdd',
    path: '/idc/ssl/sslUpload/add',
    title: '证书上传新增',
    requiresAuth: true,
    componentPath: '/idc/ssl/upload/add.vue',
    activeMenu: '/idc/ssl/sslUpload/list',
    id: 3066,
    pid: 306,
    hide: true,
  },
  {
    name: 'sslUploadInfo',
    path: '/idc/ssl/sslUpload/info/:id',
    title: '证书上传详情',
    requiresAuth: true,
    componentPath: '/idc/ssl/upload/info.vue',
    activeMenu: '/idc/ssl/sslUpload/list',
    id: 3067,
    pid: 306,
    hide: true,
  },
  {
    name: 'order',
    path: '/order',
    title: '订单管理',
    requiresAuth: true,
    icon: 'local:NewspaperOutline',
    componentPath: '/order/index.vue',
    id: 4,
    pid: null,
    keepAlive: true,
    singleParent: true, // 单一父级菜单
  },
  {
    name: 'infoOrder',
    path: '/order/info/:id',
    title: '订单详情',
    requiresAuth: true,
    componentPath: '/order/info.vue',
    activeMenu: '/order',
    id: 401,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'domainOrder',
    path: '/order/domain/:id',
    title: '域名订单详情',
    requiresAuth: true,
    componentPath: '/order/domain.vue',
    activeMenu: '/order',
    id: 402,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'cloudOrder',
    path: '/order/cloud/:id',
    title: '云主机订单详情',
    requiresAuth: true,
    componentPath: '/order/cloud.vue',
    activeMenu: '/order',
    id: 403,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'serverOrder',
    path: '/order/server/:id',
    title: '服务器订单详情',
    requiresAuth: true,
    componentPath: '/order/server.vue',
    activeMenu: '/order',
    id: 404,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'workOrder',
    path: '/workOrder',
    title: '工单管理',
    requiresAuth: true,
    icon: 'local:ReceiptOutline',
    id: 5,
    menuType: 'dir',
    componentPath: null,
    pid: null,
  },
  {
    name: 'workOrderAdd',
    path: '/workOrder/add',
    title: '提交工单',
    requiresAuth: true,
    componentPath: '/workOrder/add.vue',
    activeMenu: '/workOrder/list',
    id: 501,
    pid: null,
    hide: true,
    keepAlive: true,
    addCacheRoutes: true,
    // withoutTab: true,
  },
  {
    name: 'workOrderList',
    path: '/workOrder/list',
    title: '工单列表',
    requiresAuth: true,
    componentPath: '/workOrder/list.vue',
    id: 502,
    pid: 5,
    keepAlive: true,
  },
  {
    name: 'workOrderInfo',
    path: '/workOrder/info/:id',
    title: '工单详情',
    requiresAuth: true,
    componentPath: '/workOrder/info.vue',
    activeMenu: '/workOrder/list',
    id: 503,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'workOrderEmail',
    path: '/workOrder/email/',
    title: '短信授权',
    requiresAuth: true,
    componentPath: '/workOrder/email/index.vue',
    id: 504,
    pid: 5,
    keepAlive: true,
  },
  {
    name: 'workOrderEmailAdd',
    path: '/workOrder/email/add',
    title: '提交授权工单',
    requiresAuth: true,
    componentPath: '/workOrder/email/add.vue',
    id: 505,
    pid: null,
    hide: true,
    keepAlive: true,
    addCacheRoutes: true,
    // withoutTab: true,
  },
  {
    name: 'accountCenter',
    path: '/accountCenter',
    title: '账号中心',
    requiresAuth: true,
    icon: 'local:IdCardOutline',
    menuType: 'dir',
    componentPath: null,
    id: 6,
    pid: null,
  },
  {
    name: 'accountSecurity',
    path: '/accountCenter/accountSecurity',
    title: '账号安全',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/accountCenter/accountSecurity.vue',
    id: 601,
    pid: 6,
  },
  {
    name: 'realName',
    path: '/accountCenter/realName',
    title: '实名认证',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/accountCenter/realName/index.vue',
    id: 6020,
    pid: 6,
  },
  // {
  //   name: 'manualCertification',
  //   path: '/accountCenter/realName/manualCertification',
  //   title: '人工认证',
  //   requiresAuth: true,
  //   menuType: 'page',
  //   componentPath: '/accountCenter/realName/manualCertification.vue',
  //   activeMenu: '/accountCenter/realName',
  //   id: 6021,
  //   pid: null, // 单独非菜单页面pid要设置为null
  //   hide: true,
  //   // withoutTab: true,
  // },
  {
    name: 'certificationStatus',
    path: '/accountCenter/realName/certificationStatus',
    title: '认证状态',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/accountCenter/realName/certificationStatus.vue',
    activeMenu: '/accountCenter/realName',
    id: 6022,
    pid: null, // 单独非菜单页面pid要设置为null
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'subaccount',
    path: '/accountCenter/subaccount/',
    title: '子账号管理',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/accountCenter/subaccount/index.vue',
    id: 603,
    pid: 6,
    keepAlive: true,
  },
  {
    name: 'subaccountAdd',
    path: '/accountCenter/subaccount/add',
    title: '添加账号',
    requiresAuth: true,
    componentPath: '/accountCenter/subaccount/add.vue',
    activeMenu: '/accountCenter/subaccount/',
    id: 6030,
    pid: 6,
    hide: true,
  },
  {
    name: 'subaccountInfo',
    path: '/accountCenter/subaccount/:id',
    title: '账号详情',
    requiresAuth: true,
    componentPath: '/accountCenter/subaccount/info.vue',
    activeMenu: '/accountCenter/subaccount/',
    id: 6031,
    pid: 6,
    hide: true,
    // withoutTab: true,
  },
  // {
  //   name: 'groupPermissions',
  //   path: '/accountCenter/groupPermissions',
  //   title: '分组权限',
  //   requiresAuth: true,
  //   menuType: 'page',
  //   componentPath: '/accountCenter/groupPermissions.vue',
  //   id: 8,
  //   pid: 4,
  // },
  {
    name: 'subscribers',
    path: '/accountCenter/subscribers/',
    title: '订阅人管理',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/accountCenter/subscribers.vue',
    id: 604,
    pid: 6,
  },
  {
    name: 'contact',
    path: '/accountCenter/contact',
    title: '联系我们',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/accountCenter/contact.vue',
    id: 605,
    pid: 6,
  },
  {
    name: 'expenseCenter',
    path: '/expenseCenter/',
    title: '费用中心',
    requiresAuth: true,
    icon: 'local:LogoYen',
    menuType: 'dir',
    id: 7,
    componentPath: null,
    pid: null,
  },
  {
    name: 'expenseCenterIndex',
    path: '/expenseCenter/index',
    title: '费用信息',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/expenseCenter/index.vue',
    id: 701,
    pid: 7,
  },
  {
    name: 'expenseCenterList',
    path: '/expenseCenter/list',
    title: '账单明细',
    requiresAuth: true,
    componentPath: '/expenseCenter/list.vue',
    id: 702,
    pid: 7,
    // withoutTab: true,
  },
  // {
  //   name: 'expenseCenterTicket',
  //   path: '/expenseCenter/ticket',
  //   title: '发票管理',
  //   requiresAuth: true,
  //   menuType: 'page',
  //   componentPath: '/expenseCenter/ticket/index.vue',
  //   id: 703,
  //   pid: 7,
  //   keepAlive: true,
  // },
  {
    name: 'notices',
    path: '/accountCenter/notices',
    title: '消息中心',
    requiresAuth: true,
    icon: 'local:MegaphoneOutline',
    menuType: 'dir',
    componentPath: null,
    id: 8,
    pid: null,
  },
  {
    name: 'siteNotification',
    path: '/accountCenter/notices/siteNotification',
    title: '站内通知',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/accountCenter/notices/siteNotification.vue',
    id: 801,
    pid: 8,
    keepAlive: true,
  },
  {
    name: 'siteNotificationInfo',
    path: '/accountCenter/notices/siteNotificationInfo/:id',
    title: '站内通知详情',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/accountCenter/notices/siteNotificationInfo.vue',
    activeMenu: '/accountCenter/notices/siteNotification',
    id: 8010,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'memberAnnouncement',
    path: '/accountCenter/notices/memberAnnouncement',
    title: '会员公告',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/accountCenter/notices/memberAnnouncement.vue',
    id: 802,
    pid: 8,
    keepAlive: true,
  },
  {
    name: 'memberAnnouncementInfo',
    path: '/accountCenter/notices/memberAnnouncementInfo/:id',
    title: '会员公告详情',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/accountCenter/notices/memberAnnouncementInfo.vue',
    activeMenu: '/accountCenter/notices/memberAnnouncement',
    id: 8020,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'waitToDo',
    path: '/accountCenter/waitToDo',
    title: '待办事项',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/accountCenter/waitToDo/list.vue',
    id: 803,
    pid: 8,
    keepAlive: true,
  },
  {
    name: 'waitToDoInfo',
    path: '/accountCenter/waitToDoInfo/:id',
    title: '待办事项详情',
    requiresAuth: true,
    menuType: 'page',
    componentPath: '/accountCenter/waitToDo/info.vue',
    id: 8030,
    pid: null,
    hide: true,
  },
  {
    name: 'help',
    path: '/help',
    title: '帮助文档',
    requiresAuth: true,
    icon: 'local:Library',
    componentPath: '/help/index.vue',
    id: 9,
    pid: null,
    keepAlive: true,
    singleParent: true, // 单一父级菜单
  },
  {
    name: 'helpInfo',
    path: '/help/:id',
    title: '帮助文档详情',
    requiresAuth: true,
    componentPath: '/help/info.vue',
    activeMenu: '/help',
    id: 901,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'news',
    path: '/news/:id',
    title: '新闻详情',
    requiresAuth: true,
    componentPath: '/news.vue',
    id: 991,
    pid: null,
    hide: true,
    // withoutTab: true,
  },
  {
    name: 'searchTools',
    path: '/searchTools',
    title: '查询工具',
    requiresAuth: true,
    icon: 'local:MenuSearch',
    id: 11,
    menuType: 'dir',
    componentPath: null,
    pid: null,
  },
  {
    name: 'domainSearch',
    path: '/searchTools/domainSearch',
    title: '域名查询',
    requiresAuth: true,
    componentPath: '/searchTools/domainSearch/index.vue',
    id: 1101,
    pid: 11,
    keepAlive: true,
    addCacheRoutes: true,
  },
  {
    name: 'brandSearch',
    path: '/searchTools/brandSearch',
    title: '商标查询',
    requiresAuth: true,
    componentPath: '/searchTools/brandSearch/index.vue',
    id: 1102,
    pid: 11,
    keepAlive: true,
  },
  {
    name: 'brandSearchInfo',
    path: '/searchTools/brandSearch/info',
    title: '商标查询详情',
    requiresAuth: true,
    componentPath: '/searchTools/brandSearch/info.vue',
    activeMenu: '/searchTools/brandSearch',
    id: 1103,
    pid: 11,
    hide: true,
  },
  {
    name: 'brandSearchPhone',
    path: '/searchTools/brandSearch/search',
    title: '商标查询',
    requiresAuth: true,
    componentPath: '/searchTools/brandSearch/search.vue',
    id: 1111,
    pid: null,
    hide: true,
  },
  {
    name: 'brandSearchMInfo',
    path: '/searchTools/brandSearch/minfo',
    title: '商标查询详情',
    requiresAuth: true,
    componentPath: '/searchTools/brandSearch/mInfo.vue',
    id: 1112,
    pid: null,
    hide: true,
  },
  {
    name: 'patentSearch',
    path: '/searchTools/patentSearch',
    title: '专利查询',
    requiresAuth: true,
    componentPath: '/searchTools/patentSearch/index.vue',
    id: 1104,
    pid: 11,
    isIframe: '/searchTools/patentSearch/index.vue',
  },
  {
    name: 'patentSearchPhone',
    path: '/searchTools/patentSearch/search',
    title: '专利查询',
    requiresAuth: true,
    componentPath: '/searchTools/patentSearch/search.vue',
    id: 1113,
    pid: 11,
    hide: true,
    keepAlive: true,
  },
  {
    name: 'patentSearchMInfo',
    path: '/searchTools/patentSearch/minfo',
    title: '专利查询详情',
    requiresAuth: true,
    componentPath: '/searchTools/patentSearch/minfo.vue',
    id: 1114,
    pid: 11,
    hide: true,
  },
  {
    name: 'ipSearch',
    path: '/searchTools/ipSearch',
    title: 'IP查询',
    requiresAuth: true,
    componentPath: '/searchTools/ipSearch/index.vue',
    id: 1105,
    pid: 11,
  },
  {
    name: 'whoisSearch',
    path: '/searchTools/whoisSearch',
    title: 'Whois查询',
    requiresAuth: true,
    componentPath: '/searchTools/whoisSearch/index.vue',
    id: 1106,
    pid: 11,
  },
  {
    name: 'niceSearch',
    path: '/searchTools/niceSearch',
    title: '尼斯分类查询',
    requiresAuth: true,
    componentPath: '/searchTools/niceSearch/index.vue',
    id: 1107,
    pid: 11,
    keepAlive: true,
  },
  {
    name: 'niceSearchInfo',
    path: '/searchTools/niceSearch/info/:id',
    title: '尼斯分类详情',
    requiresAuth: true,
    componentPath: '/searchTools/niceSearch/nice/info.vue',
    id: 1108,
    pid: 11,
    hide: true,
    activeMenu: '/searchTools/niceSearch',
  },
  {
    name: 'niceSearchRetrieval',
    path: '/searchTools/niceSearch/retrieval',
    title: '尼斯分类详情查询',
    requiresAuth: true,
    componentPath: '/searchTools/niceSearch/retrieval.vue',
    id: 1109,
    pid: 11,
    hide: true,
    activeMenu: '/searchTools/niceSearch',
    keepAlive: true,
  },
  {
    name: 'niceSearchCart',
    path: '/searchTools/cart',
    title: '购物车',
    requiresAuth: true,
    componentPath: '/searchTools/cart/index.vue',
    id: 1110,
    pid: 11,
    hide: true,
    keepAlive: true,
  },
  // {
  //   name: 'test',
  //   path: '/test',
  //   title: '测试',
  //   requiresAuth: true,
  //   icon: 'local:NewspaperOutline',
  //   componentPath: '/test.vue',
  //   id: 9999,
  //   pid: 11,
  //   isIframe: '/test.vue',
  // },
]
